import React, {useState, useEffect} from 'react';
import axios from '../../api';
import Swal from "sweetalert2";
import {Grid, IconButton, Menu, MenuItem} from '@material-ui/core';
import ListarSenhasComponent from '../ thirdComponents/accordions/ListarSenhasComponent';
import MoreVertIcon from '@material-ui/icons/MoreVert'
import '../../App.css';
import Panel from '../Painel';
import beep from '../../assets/audio/beep.mp3'


function SenhasComponent() {

    const [showPanel, setShowPanel] = useState(false);

    const [tableKey, setTableKey] = useState(0); // add key to table component


    //use state ta bela
    const [tabelaVisivel, setTabelaVisivel] = useState(true); // Define o estado "tabelaVisivel" como true

    const [anchorEl, setAnchorEl] = useState(null);

    //pega a senha atual que esta sendo exibida no painel do paciente
    const [senhaAtual, setSenhaAtual] = useState('');

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleShow() {
        setTabelaVisivel(!tabelaVisivel); // Alterna o estado "tabelaVisivel" ao clicar no botão
    }

    //evento de click que aciona o audio
    const handleButtonClick = () => {
        const audio = new Audio(beep);
        audio.play();
    }

    //abre o painel

    function handleMenuClick() {
        window.open('/painel', '_blank');
    }


    const [results, setTableData] = useState([]);

    function fetchData() {
        const token = localStorage.getItem('token');
        axios.get('/senha', {
            timeout: 10000,
            headers: { Authorization: `bearer ${token}` }
        })
            .then(response => {
                const results = response.data.data;
                setTableData(results);
                //pega a segunha atual e realiza as alterações
                if (results.length > 0) {
                    setSenhaAtual(results[0].id);
                }
            })
            .catch(error => {
                console.log('Error fetching data:', error);
            });
    }

    useEffect(() => {
        fetchData();
    }, []);


    // Aqui é onde você pode exibir a primeira senha em um componente diferente
    const primeiraSenha = results.length > 0 ? results[0].name : '';
    //nome
    const senha = results.length > 0 ? results[0].senha : '';


    //método para realizar o atendimento do paciente
    function atenderPaciente() {
        Swal.fire({
            title: 'Você tem certeza ?',
            text: 'Você tem certeza que deseja encaminhar esse paciente para o procedimento final de triagem? Uma vez enviado essa modificação não poderá ser desfeita.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Encaminhar',
            cancelButtonText: 'Cancelar'

        }).then(async (result) => {
            if (result.isConfirmed) {
                
                try {
                    // aqui você pode colocar uma mensagem de sucesso ou redirecionar o usuário para outra página
                    await axios.put(`/triagem/atendimento/${senhaAtual}`, {encaminharParatriagem: true});

                    Swal.fire({
                        icon: 'success',
                        title: 'Muito bem',
                        text: 'Paciente foi redirecionado para a guia de ATENDER PACIENTE.',
                        footer: 'Por favor, feche esta janela e vá até a guia informada para continuar o atendimento do paciente.'
                    });
                    // refresh table component by updating its key
                    setTableKey(tableKey => tableKey + 1);
                    const audio = new Audio(beep);
                    await audio.play();
                    fetchData();
                } catch (error) {
                    console.error(error);
                    // aqui você pode colocar uma mensagem de erro para o usuário
                }
            }
        })
    }

    //chama a proxima senha descantando o paciente da fila de senhas
    function proximoPaciente() {
        Swal.fire({
            title: 'Você tem certeza ?',
            text: 'Ao chamar a próxima senha você está indicando que este paciente não está mais na unidade, portante irá tirar ele da lista.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Retirar da fila',
            cancelButtonText: 'Cancelar'

        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // aqui você pode colocar uma mensagem de sucesso ou redirecionar o usuário para outra página
                        await axios.put(`/triagem/next/${senhaAtual}`, {proxima: true});

                    Swal.fire({
                        icon: 'success',
                        title: 'Muito bem',
                        text: 'Paciente foi removido da lista.',
                        footer: 'Por favor, caso ele retorne e queira incluir ele novamente basta ir até HOME e localizar a senha do paciente novamente .'
                    });
                    // refresh table component by updating its key
                    setTableKey(tableKey => tableKey + 1);
                    const audio = new Audio(beep);
                    await audio.play();
                    fetchData();
                } catch (error) {
                    console.error(error);
                    // aqui você pode colocar uma mensagem de erro para o usuário
                }
            }
        })
    }

    return (
        <div>
            <br/>
            <Grid item xs={12}>
                <div className="senha-panel animate__animated animate__backInLeft">
                    <IconButton className="menu-button" onClick={handleClick}>
                        <MoreVertIcon className="menu-button"/>
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleMenuClick} >Painel</MenuItem>   {showPanel && <Panel   />}
                    </Menu>
                    <div className="paciente-header">Aguardando Paciente :</div>
                        <div className="paciente-name">{primeiraSenha.toUpperCase()}</div>
                    <div className="senha-header">Senha :</div>
                    <div className="senha-number">{senha}</div>
                    <button className="danger" onClick={handleButtonClick}>
                        Chamar Novamente
                    </button>
                    <button className="warning" onClick={atenderPaciente}>
                        Atender Paciente
                    </button>
                    <button className="primary"  onClick={proximoPaciente}>
                        Próxima
                    </button>
                </div>
            </Grid>
            <br/>
            <Grid item xs={12}>
                <ListarSenhasComponent key={tableKey}/>
                <div className="container-senhas">
                    <br/>
                    <div className="carregar">
                        <button onClick={handleShow} className="secondary">
                            Carregar
                        </button>
                    </div>
                </div>
            </Grid>

        </div>
    );
}

export default SenhasComponent;